/**
 * Bunny Stream video - click-to-load
 *
 * Nothing is requested from Bunny until the visitor clicks the preview image.
 * The click replaces the poster with the player iframe and starts playback.
 */

function loadVideo(poster) {
    const src = poster.dataset.bunnyVideo;
    const iframe = document.createElement('iframe');
    iframe.src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'autoplay=true';
    iframe.title = poster.dataset.bunnyVideoTitle || '';
    iframe.className = 'embed-responsive-item';
    iframe.setAttribute('allow', 'accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture; fullscreen');
    iframe.setAttribute('allowfullscreen', '');

    poster.replaceWith(iframe);
    iframe.focus();
}

function initBunnyVideos() {
    document.querySelectorAll('[data-bunny-video]').forEach(function (poster) {
        poster.addEventListener('click', function () {
            loadVideo(poster);
        }, { once: true });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBunnyVideos);
} else {
    initBunnyVideos();
}
